export enum CurrencyIso {
  CHF = 'CHF',
  EUR = 'EUR',
  GBP = 'GBP',
  JPY = 'JPY',
  USD = 'USD',
  HUF = 'HUF'
}

const convertCurrencyIso = (currencyIsoStr: string): CurrencyIso => {
  switch (currencyIsoStr) {
    case 'HUF':
      return CurrencyIso.HUF;
    case 'CHF':
      return CurrencyIso.CHF;
    case 'EUR':
      return CurrencyIso.EUR;
    case 'GBP':
      return CurrencyIso.GBP;
    case 'JPY':
      return CurrencyIso.JPY;
    case 'USD':
      return CurrencyIso.USD;
    default:
      throw new Error('Unknown currency ISO: ' + currencyIsoStr);
  }
};

export default convertCurrencyIso;
